<img *ngIf="(small$ | async) && !((medium$ | async) && medium) && small" [src]="small" alt=""/>
<img *ngIf="(medium$ | async) && !((large$ | async) && large) && medium" [src]="medium" alt=""/>
<img *ngIf="(large$ | async) && !((xlarge$ | async) && xlarge) && large" [src]="large" alt=""/>
<img *ngIf="(xlarge$ | async) && !((xxlarge$ | async) && xxlarge) && xlarge" [src]="xlarge" alt=""/>
<img *ngIf="(xxlarge$ | async) && xxlarge" [src]="xxlarge" alt=""/>
